import { render, staticRenderFns } from "./PEnvironmentWidget.vue?vue&type=template&id=a6620a1a"
import script from "./PEnvironmentWidget.vue?vue&type=script&lang=js"
export * from "./PEnvironmentWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports